import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0c383f8a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "",
  style: {
    "height": "100vh",
    "background-color": "#f7f7f7"
  }
};
const _hoisted_2 = {
  style: {
    "width": "98%",
    "margin": "0 auto",
    "margin-top": "55px",
    "box-shadow": "0 0 0.5em #ddd",
    "border-radius": "0.5em",
    "padding-left": "10px",
    "padding-top": "10px",
    "padding-bottom": "10px"
  },
  class: "bg-white"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "",
  class: "text font-bold text-center line-height",
  style: {
    "padding": "5px",
    "margin-top": "10px",
    "margin-right": "10px",
    "background-color": "#f7f7f7"
  }
}, " 请先指定一位您专属的在线名师 ", -1));
const _hoisted_4 = {
  id: "",
  style: {
    "margin-top": "10px",
    "margin-right": "10px"
  }
};
const _hoisted_5 = {
  style: {
    "width": "98%",
    "margin": "0 auto",
    "margin-top": "15px",
    "box-shadow": "0 0 0.5em #ddd",
    "border-radius": "0.5em",
    "padding-left": "10px",
    "padding-top": "10px",
    "padding-bottom": "10px"
  },
  class: "bg-white"
};
const _hoisted_6 = {
  key: 0,
  id: "",
  style: {
    "height": "10px"
  }
};
const _hoisted_7 = {
  key: 1,
  style: {
    "padding": "5px"
  },
  id: ""
};
const _hoisted_8 = {
  id: "",
  class: "flex align-center",
  style: {
    "justify-content": "space-between"
  }
};
const _hoisted_9 = {
  id: "",
  class: "flex align-center"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  id: "",
  style: {
    "font-weight": "700",
    "font-size": "18px"
  }
};
import { useStore } from "vuex";
import { reactive, ref, computed } from "vue";
import Title from "../../../components/title.vue";
import { getLocalPid } from "../../../libs/util";
import { bizQueryTeacher, bizSetTeacher, bizAutoSetTeacher } from "../../../api/index";
import { ElMessage } from "element-plus";
const teacher_id = "";
export default {
  __name: 'teacher',
  setup(__props) {
    const store = useStore();
    const safeMes = computed(() => store.state.safeMes);
    const ac = ref(false);
    const teacher_msg = reactive({
      data: {}
    });
    const getTeacherList = () => {
      let obj = {
        ...safeMes.value,
        pid: getLocalPid(),
        teacher_id: teacher_id
      };
      bizQueryTeacher(encodeURIComponent(JSON.stringify(obj))).then(({
        data
      }) => {
        if (data.code) return store.commit("judgeCode", {
          code: data.code,
          msg: data.msg
        });
        if (!data.data.length) {
          return ElMessage.error("名师id不存在哦");
        }
        teacher_msg.data = {
          ...data.data[0]
        };
      }).catch(err => {
        ElMessage.error(err);
      });
    };
    const selectTeacher = () => {
      let obj = {
        ...safeMes.value,
        pid: getLocalPid(),
        teacher_id: teacher_msg.data.teacher_id
      };
      bizSetTeacher(encodeURIComponent(JSON.stringify(obj))).then(({
        data
      }) => {
        console.log(data);
        if (data.code) return store.commit("judgeCode", {
          code: data.code,
          msg: data.msg
        });
        window.location.href = data.data;
      }).catch(err => {
        ElMessage.error(err);
      });
    };
    const allocate = () => {
      //
      let obj = {
        ...safeMes.value,
        pid: getLocalPid()
      };
      bizAutoSetTeacher(encodeURIComponent(JSON.stringify(obj))).then(({
        data
      }) => {
        if (data.code) return store.commit("judgeCode", {
          code: data.code,
          msg: data.msg
        });
        window.location.href = data.data;
      }).catch(err => {
        ElMessage.error(err);
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Title), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("input", {
        class: _normalizeClass(ac.value ? 'active' : ''),
        style: {
          "width": "100%",
          "padding": "5px",
          "background-color": "#ffffff"
        },
        type: "",
        name: "",
        id: "",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => teacher_id = $event),
        placeholder: "请输入名师ID",
        onClick: _cache[1] || (_cache[1] = $event => ac.value = true),
        onBlur: _cache[2] || (_cache[2] = $event => ac.value = false)
      }, null, 34), [[_vModelText, teacher_id]])]), _createElementVNode("div", {
        class: "font-bold text-center",
        style: {
          "background-color": "#66afe9",
          "color": "white",
          "width": "99.5%",
          "padding": "5px",
          "border-radius": "0.3em",
          "margin-top": "5px"
        },
        onClick: _cache[3] || (_cache[3] = $event => getTeacherList())
      }, " 查找名师 "), _createElementVNode("div", {
        class: "font-bold text-center",
        style: {
          "background-color": "#66afe9",
          "color": "white",
          "width": "99.5%",
          "padding": "5px",
          "border-radius": "0.3em",
          "margin-top": "5px"
        },
        onClick: allocate
      }, " 自动为我分配名师 ")]), _createElementVNode("div", _hoisted_5, [!teacher_msg.data.nickname ? (_openBlock(), _createElementBlock("div", _hoisted_6)) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
        src: teacher_msg.data.avatar,
        style: {
          "border-radius": "10px",
          "height": "50px",
          "width": "50px",
          "margin-right": "30px"
        }
      }, null, 8, _hoisted_10), _createElementVNode("div", _hoisted_11, _toDisplayString(teacher_msg.data.nickname), 1)]), _createElementVNode("div", {
        id: "",
        style: {
          "background-color": "#66afe9",
          "color": "white",
          "font-weight": "700",
          "width": "80px",
          "padding": "5px 10px",
          "border-radius": "5px",
          "margin-top": "3px",
          "margin-right": "10px"
        },
        onClick: selectTeacher
      }, " 选定名师 ")])]))])]);
    };
  }
};